import React from 'react';
import type { IconSidebarMenu } from 'commons/modules/SidebarMenu/icon-sidebar-menu';
import { MENU_KEYS } from 'constants/constants';

const FundsIcon = ({
  open,
  disabled,
  currentImage,
  isExpanded,
  returnPath,
}: IconSidebarMenu) => {
  const logicOp = () => {
    const currentImg = currentImage === MENU_KEYS.funds;
    const expanded = isExpanded === `panel${MENU_KEYS.funds}`;
    const path = returnPath('^/fondos(?:/|$)');

    return Boolean(currentImg || (path && !open) || (expanded && open));
  };

  if (disabled && currentImage !== MENU_KEYS.funds) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#525067" />
        <path
          d="M27 14C24.29 14 21.95 15.54 20.78 17.78C19.4961 18.4488 18.4488 19.4961 17.78 20.78C16.6409 21.3714 15.686 22.2641 15.0195 23.361C14.3529 24.4578 14.0003 25.7165 14 27C14 30.87 17.13 34 21 34C23.71 34 26.05 32.46 27.22 30.22C28.5039 29.5512 29.5512 28.5039 30.22 27.22C31.3591 26.6286 32.314 25.7359 32.9805 24.639C33.6471 23.5422 33.9997 22.2835 34 21C34 17.13 30.87 14 27 14ZM21 32C20.0717 31.9993 19.162 31.7402 18.3726 31.2519C17.5832 30.7636 16.9452 30.0652 16.5301 29.235C16.1149 28.4047 15.939 27.4753 16.022 26.5508C16.105 25.6262 16.4436 24.743 17 24C17 27.87 20.13 31 24 31C23.16 31.63 22.12 32 21 32ZM24 29C23.0717 28.9993 22.162 28.7402 21.3726 28.2519C20.5832 27.7636 19.9452 27.0652 19.5301 26.235C19.1149 25.4047 18.939 24.4753 19.022 23.5508C19.105 22.6262 19.4436 21.743 20 21C20 24.86 23.13 27.99 27 28C26.16 28.63 25.12 29 24 29ZM28.7 25.7C28.17 25.89 27.6 26 27 26C24.24 26 22 23.76 22 21C22 20.4 22.11 19.83 22.3 19.3C22.83 19.11 23.4 19 24 19C26.76 19 29 21.24 29 24C29 24.6 28.89 25.17 28.7 25.7ZM31 24C31 20.14 27.87 17.01 24 17C24.9633 16.2817 26.1531 15.9341 27.3516 16.021C28.5501 16.1078 29.6773 16.6232 30.527 17.473C31.3768 18.3227 31.8922 19.4499 31.979 20.6484C32.0659 21.8469 31.7183 23.0367 31 24Z"
          fill="#757A96"
        />
      </svg>
    );
  }
  return (
    <>
      {logicOp() ? (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" fill="#F4F2F9" />
          <path
            d="M27 14C24.29 14 21.95 15.54 20.78 17.78C19.4961 18.4488 18.4488 19.4961 17.78 20.78C16.6409 21.3714 15.686 22.2641 15.0195 23.361C14.3529 24.4578 14.0003 25.7165 14 27C14 30.87 17.13 34 21 34C23.71 34 26.05 32.46 27.22 30.22C28.5039 29.5512 29.5512 28.5039 30.22 27.22C31.3591 26.6286 32.314 25.7359 32.9805 24.639C33.6471 23.5422 33.9997 22.2835 34 21C34 17.13 30.87 14 27 14ZM21 32C20.0717 31.9993 19.162 31.7402 18.3726 31.2519C17.5832 30.7636 16.9452 30.0652 16.5301 29.235C16.1149 28.4047 15.939 27.4753 16.022 26.5508C16.105 25.6262 16.4436 24.743 17 24C17 27.87 20.13 31 24 31C23.16 31.63 22.12 32 21 32ZM24 29C23.0717 28.9993 22.162 28.7402 21.3726 28.2519C20.5832 27.7636 19.9452 27.0652 19.5301 26.235C19.1149 25.4047 18.939 24.4753 19.022 23.5508C19.105 22.6262 19.4436 21.743 20 21C20 24.86 23.13 27.99 27 28C26.16 28.63 25.12 29 24 29ZM28.7 25.7C28.17 25.89 27.6 26 27 26C24.24 26 22 23.76 22 21C22 20.4 22.11 19.83 22.3 19.3C22.83 19.11 23.4 19 24 19C26.76 19 29 21.24 29 24C29 24.6 28.89 25.17 28.7 25.7ZM31 24C31 20.14 27.87 17.01 24 17C24.9633 16.2817 26.1531 15.9341 27.3516 16.021C28.5501 16.1078 29.6773 16.6232 30.527 17.473C31.3768 18.3227 31.8922 19.4499 31.979 20.6484C32.0659 21.8469 31.7183 23.0367 31 24Z"
            fill="#6D46DD"
          />
        </svg>
      ) : (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" fill="#525067" />
          <path
            d="M27 14C24.29 14 21.95 15.54 20.78 17.78C19.4961 18.4488 18.4488 19.4961 17.78 20.78C16.6409 21.3714 15.686 22.2641 15.0195 23.361C14.3529 24.4578 14.0003 25.7165 14 27C14 30.87 17.13 34 21 34C23.71 34 26.05 32.46 27.22 30.22C28.5039 29.5512 29.5512 28.5039 30.22 27.22C31.3591 26.6286 32.314 25.7359 32.9805 24.639C33.6471 23.5422 33.9997 22.2835 34 21C34 17.13 30.87 14 27 14ZM21 32C20.0717 31.9993 19.162 31.7402 18.3726 31.2519C17.5832 30.7636 16.9452 30.0652 16.5301 29.235C16.1149 28.4047 15.939 27.4753 16.022 26.5508C16.105 25.6262 16.4436 24.743 17 24C17 27.87 20.13 31 24 31C23.16 31.63 22.12 32 21 32ZM24 29C23.0717 28.9993 22.162 28.7402 21.3726 28.2519C20.5832 27.7636 19.9452 27.0652 19.5301 26.235C19.1149 25.4047 18.939 24.4753 19.022 23.5508C19.105 22.6262 19.4436 21.743 20 21C20 24.86 23.13 27.99 27 28C26.16 28.63 25.12 29 24 29ZM28.7 25.7C28.17 25.89 27.6 26 27 26C24.24 26 22 23.76 22 21C22 20.4 22.11 19.83 22.3 19.3C22.83 19.11 23.4 19 24 19C26.76 19 29 21.24 29 24C29 24.6 28.89 25.17 28.7 25.7ZM31 24C31 20.14 27.87 17.01 24 17C24.9633 16.2817 26.1531 15.9341 27.3516 16.021C28.5501 16.1078 29.6773 16.6232 30.527 17.473C31.3768 18.3227 31.8922 19.4499 31.979 20.6484C32.0659 21.8469 31.7183 23.0367 31 24Z"
            fill="#F4F2F9"
          />
        </svg>
      )}
    </>
  );
};

export default FundsIcon;
